export type PublicShareRoute = {
  slug: string;
};

export const PUBLIC_SHARE_ROUTE = 'adr-case';
const LEGACY_PUBLIC_SHARE_ROUTES = ['ai', 'question'];

export function buildPublicSharePath(slug: string): string {
  return `/${PUBLIC_SHARE_ROUTE}/${encodeURIComponent(slug)}`;
}

export function readPublicShareRoute(pathname: string): PublicShareRoute | null {
  const segments = pathname.split('/').filter(Boolean);
  const route = segments[0];
  const routeParts = segments.slice(1);

  if (isPublicShareRouteSegment(route) && routeParts.length === 1) {
    return decodeShareRouteSlug(routeParts[0]);
  }

  return null;
}

export function readPublicShareSlugFromUrl(url: string): string {
  try {
    return readPublicShareRoute(new URL(url).pathname)?.slug || '';
  } catch {
    return '';
  }
}

function isPublicShareRouteSegment(route: string | undefined): boolean {
  return route === PUBLIC_SHARE_ROUTE || LEGACY_PUBLIC_SHARE_ROUTES.includes(route || '');
}

function decodeShareRouteSlug(rawSlug: string): PublicShareRoute | null {
  try {
    const slug = decodeURIComponent(rawSlug);
    return slug ? { slug } : null;
  } catch {
    return null;
  }
}
